import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { useCurrentNamespace } from '@modules/permissions/composables';

import type {
  IAffiliateProfileData,
  IAffiliateProfileDataResponse,
} from '../types';
import {
  AFFILIATE_PROFILE_SETTINGS_QUERY_KEY,
  AFFILIATE_PROFILE_SETTINGS_URL,
  PROFILE_SETTINGS_PERMISSIONS,
} from '../constants';

export default function useAffiliateProfileQuery(): IContextQueryResult<
  IAffiliateProfileDataResponse,
  Error,
  IAffiliateProfileData
> {
  const { fetchGet } = useRestClient();
  const { isAffiliateNamespace } = useCurrentNamespace();

  return useContextQuery<
    IAffiliateProfileDataResponse,
    Error,
    IAffiliateProfileData
  >({
    queryKey: [AFFILIATE_PROFILE_SETTINGS_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IAffiliateProfileDataResponse>(
      AFFILIATE_PROFILE_SETTINGS_URL,
      {
        signal,
        permission: PROFILE_SETTINGS_PERMISSIONS.SHOW,
      },
    ),
    select: (data) => data.profile,
    enabled: isAffiliateNamespace,
  });
}
